import MapScale from '@/Enums/Map/MapScale.enum';
import { BeeswaxReportProperties } from '@/Enums/Report/BeeswaxReportProperties.enum';
import ReportView from '@/Enums/ReportingDashboard/ReportView/ReportView.enum';
import { MAP_SCALES } from './geo';

export const PLACEMENT_TAB_INDEX = 0;

export const BASE_TAB_ID = 'reporting-filter-tab';

export const IMPRESSIONS_REPORT_CSV = 'Impressions Report';
export const PUBLISHER_NAME = 'Publisher Name';

export const IMPRESSION_TYPES = {
  DATE: 'Day',
  CHANNEL: 'Digital Channel',
  DEVICE: 'Device Type',
  ADVERTISER: 'Advertiser',
  CAMPAIGN: 'Campaign Name',
  PLACEMENT: 'Line Item Name',
  CREATIVE: 'Creative Name',
  VENUE_TYPE: 'Venue Type',
  PUBLISHER: PUBLISHER_NAME,
  DAYS_OF_WEEK: BeeswaxReportProperties.DAY_OF_WEEK,
  DAYPART: 'Daypart',
  AUDIENCE: 'Segment Name',
  DEALS: 'Deals',
  GEO_STATE_VALUE: 'Region/State',
  GEO_ZIP_VALUE: 'Geo Zip',
  GEO_DMA_VALUE: 'Metro/DMA',
  GEO_COUNTY_VALUE: 'Geo County',
  GENRE: 'Genre',
  GEO_CONGRESSIONAL_DISTRICTS_VALUE: 'Geo Congressional Districts',
  CITY: 'City',
  PIXEL: 'Pixel',
};

export const GOOGLE_REPORT_FIELDS = {
  [ReportView.Date]: 'dateData',
  [ReportView.Channel]: 'channelData',
  [ReportView.Device]: 'deviceData',
  [ReportView.Advertiser]: 'advertiserData',
  [ReportView.Campaign]: 'campaignData',
  [ReportView.Placement]: 'placementData',
  [ReportView.Creative]: 'creativeData',
  [ReportView.Publisher]: 'publisherData',
  [ReportView.DaysOfWeek]: 'daysOfWeekData',
  [ReportView.App]: 'appUrlReport',
  [ReportView.Daypart]: 'daypartData',
  [MapScale.State]: 'stateData',
  [MapScale.Dma]: 'dmaData',
};

export const IMPRESSION_TYPE_LABELS = {
  [IMPRESSION_TYPES.DATE]: 'Date',
  [IMPRESSION_TYPES.CHANNEL]: 'Channel',
  [IMPRESSION_TYPES.DEVICE]: 'Device',
  [IMPRESSION_TYPES.CAMPAIGN]: 'Campaign',
  [IMPRESSION_TYPES.ADVERTISER]: 'Advertiser',
  [IMPRESSION_TYPES.PLACEMENT]: 'Placement',
  [IMPRESSION_TYPES.CREATIVE]: 'Creative',
  [IMPRESSION_TYPES.PUBLISHER]: 'Publisher',
  [IMPRESSION_TYPES.DAYS_OF_WEEK]: 'Days of Week',
  [IMPRESSION_TYPES.DAYPART]: 'Daypart',
  [IMPRESSION_TYPES.AUDIENCE]: 'Audience',
  [IMPRESSION_TYPES.PIXEL]: 'Pixels',
  [IMPRESSION_TYPES.DEALS]: 'Deals',
  [IMPRESSION_TYPES.GEO_STATE_VALUE]: 'State',
  [MAP_SCALES.STATE]: 'State',
  [IMPRESSION_TYPES.GEO_DMA_VALUE]: 'DMA',
  [MAP_SCALES.DMA]: 'DMA',
  [IMPRESSION_TYPES.GEO_ZIP_VALUE]: 'ZIP',
  [MAP_SCALES.ZIP]: 'ZIP',
  [IMPRESSION_TYPES.GEO_COUNTY_VALUE]: 'County',
  [MAP_SCALES.COUNTY]: 'County',
  [IMPRESSION_TYPES.GEO_CONGRESSIONAL_DISTRICTS_VALUE]: 'Congressional Districts',
  [MAP_SCALES.CONGRESSIONAL_DISTRICTS]: 'Congressional Districts',
  // NEURON
  [IMPRESSION_TYPES.VENUE_TYPE]: 'Venue Type',
};

export const API_TABS_FILTER_TAB_ID = 'reporting-filter-tabs';
export const API_TABS_BASE_TAB_ID = 'reporting-api-tabs';

export const MIN_GOOGLE_DATE_RANGE_START = '2024-07-01';
export const GOOGLE_REPORT_DATE_RANGE_LIMIT = 93;
